class DateFigure {
    constructor(pravac1, pravac2, pravac3){
        this.pravac1=pravac1;
        this.pravac2=pravac2;
        this.pravac3=pravac3;
    }
}

export {DateFigure as default}